import { render, staticRenderFns } from "./AppointmentGridDetails.vue?vue&type=template&id=0d6aa576&"
import script from "./AppointmentGridDetails.vue?vue&type=script&lang=js&"
export * from "./AppointmentGridDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports